import { createContext, useContext } from 'react';
import { MergedPermission } from '../types';

type PermissionsContextType = {
  getPermissionById: (id: number) => MergedPermission | undefined;
  isLoadingPermissions: boolean;
  permissions: MergedPermission[];
  permissionsById: { [key: string]: MergedPermission };
  refetchPermissions: () => void;
};

const defaultState = {
  getPermissionById: () => undefined,
  isLoadingPermissions: false,
  permissions: [],
  permissionsById: {},
  refetchPermissions: () => undefined,
};

export const PermissionsContext = createContext<PermissionsContextType>(defaultState);

export const usePermissionsContext = () => useContext<PermissionsContextType>(PermissionsContext);
